<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un rapport..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
  <!-- Groupe principal de boutons arrondis -->
            <div class="btn-group rounded-pill" role="group" aria-label="Basic example">
  <div class="btn-group dropdown">
                    <button type="button" class="btn btn-outline-primary btn-sm rounded-start-pill "
                            data-bs-toggle="dropdown"
                    >
                        @if (loadingRapport || loadingPdfGen || loadingOT ) {
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span class="px-2">Chargement</span>
                        } @else {
                            <i class="fa-solid fa-flask px-4"></i>
                        }
                    </button>
                    <ul class="dropdown-menu">
                        <div class="row d-flex justify-content-center" style="width: 210px">
                            <div class="col-lg-12">
                                <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2 "
                                        [disabled]="loadingOT"
                                        (click)="downloadRapport()">
                                    @if (loadingOT) {
                                        <span class="spinner-grow spinner-grow-sm" role="status"
                                              aria-hidden="true"></span>
                                        <span class="px-2">Chargement</span>
                                    } @else {
                                        <span class="px-2">Rapport</span>
                                    }
                                </button>
                            </div>

                        </div>
                        <div class="row d-flex justify-content-center" style="width: 210px">
                            <div class="col-lg-12">
                                <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2 "
                                        [disabled]="loadingOT"
                                        (click)="signerRapport()"
                                             *ngIf="isRL">
                                    @if (loadingOT) {
                                        <span class="spinner-grow spinner-grow-sm" role="status"
                                              aria-hidden="true"></span>
                                        <span class="px-2">Chargement</span>
                                    } @else {
                                        <span class="px-2">Signer</span>
                                    }
                                </button>
                            </div>

                        </div>
                        <div class="row d-flex justify-content-center" style="width: 210px">
                            <div class="col-lg-12">
                                <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2 "
                                        [disabled]="loadingOT"
                                        (click)="reviserRapport()">
                                    @if (loadingOT) {
                                        <span class="spinner-grow spinner-grow-sm" role="status"
                                              aria-hidden="true"></span>
                                        <span class="px-2">Chargement</span>
                                    } @else {
                                        <span class="px-2">Réviser</span>
                                    }
                                </button>
                            </div>

                        </div>
                    </ul>
   </div>
    <!-- Bouton Dropdown -->
    <div class="btn-group dropdown">
      <button type="button"
              class="btn btn-outline-primary btn-sm rounded-end-pill"
              [matMenuTriggerFor]="menu"
              aria-haspopup="true"
              aria-expanded="false">
        <i class="fa-solid fa-arrow-down-short-wide px-3"></i>
      </button>
    </div>

  </div>
</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                    <!-- select Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell
                            *matHeaderCellDef>
                            <mat-checkbox (change)="handleSelectAll()" [checked]="isAllRapportSelected"/>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isAllRapportSelected" (change)="handleSelection(element)"/>
                        </td>
                    </ng-container>

                    <!-- Report Number Column -->
                    <ng-container matColumnDef="reportNumber">
                        <th mat-header-cell *matHeaderCellDef>Numéro du Rapport</th>
                          <td mat-cell *matCellDef="let element">
                            <a [routerLink]="['/rapport-details', element.id]">{{ element.reportNumber }}</a>
                          </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Statut</th>
                        <td mat-cell *matCellDef="let element"> {{ element.status }}</td>
                    </ng-container>
                    <!-- Interpretations Column -->
                    <!-- Creation Date Column -->
                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef> Céé le</th>
                        <td mat-cell *matCellDef="let element"> {{ element.creationDate | date }}</td>
                    </ng-container>

                    <!-- Update Date Column -->
                    <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef> Modifié le</th>
                        <td mat-cell *matCellDef="let element"> {{ element.updateDate | date }}</td>
                    </ng-container>

                    <!-- Client Name Column 
                    <ng-container matColumnDef="clientName">
                        <th mat-header-cell *matHeaderCellDef> Client</th>
                        <td mat-cell *matCellDef="let element"> {{ element.clientName }}</td>
                    </ng-container>-->

                    <!-- User Name Column -->
                    <ng-container matColumnDef="userName">
                        <th mat-header-cell *matHeaderCellDef> Céé par</th>
                        <td mat-cell *matCellDef="let element"> {{ element.userName }}</td>
                    </ng-container>

                <ng-container matColumnDef="sampleCode">
                    <th mat-header-cell *matHeaderCellDef> Échantillon</th>
                    <td mat-cell *matCellDef="let element">
                        {{ getSampleCodes(element.sampleAnalyses) }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="referenceInterne">
                    <th mat-header-cell *matHeaderCellDef> Réference interne</th>
                    <td mat-cell *matCellDef="let element">
                        {{ getReferenceInterne(element.sampleAnalyses) }}
                    </td>
                </ng-container>
                    <!-- Table Header and Rows -->
                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Action</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">

                                <button type="button" mat-button matTooltip="Visualiser les détails"
                                        matTooltipPosition="above" (click)="openViewModel(element, viewModal)"
                                >
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element, editModal)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
  
                                <!-- Bouton PDF 
                                <button type="button"
                                        mat-button
                                        matTooltip="Télécharger le rapport PDF"
                                        matTooltipPosition="above"
                                        (click)="downloadRapport()">
                                        <i class="fa-solid fa-file-pdf text-success"></i>
                                </button>
                                -->
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="7">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>
                </table>
                <div *ngIf="selectedHistoryList.length > 0" class="mt-4">
                    <h4>Historique du Rapport ID : {{ selectedRapportId }}</h4>
                    <table mat-table [dataSource]="selectedHistoryList" class="mat-elevation-z8">
                  
                      <!-- Numéro de version -->
                      <ng-container matColumnDef="versionNumber">
                        <th mat-header-cell *matHeaderCellDef>Version</th>
                        <td mat-cell *matCellDef="let history"> {{ history.versionNumber }} </td>
                      </ng-container>
                  
                      <!-- Date de création -->
                      <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef>Créé le</th>
                        <td mat-cell *matCellDef="let history"> {{ history.creationDate | date:'short' }} </td>
                      </ng-container>
                  
                      <!-- Statut -->
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Report number</th>
                        <td mat-cell *matCellDef="let history"> {{ history.report_number }} </td>
                      </ng-container>
                  
                      <!-- Actions -->
                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Action</th>
                        <td mat-cell *matCellDef="let history">
                          <button mat-icon-button (click)="downloadPdf(history)">
                            <mat-icon>download</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                  
                      <tr mat-header-row *matHeaderRowDef="['versionNumber', 'creationDate', 'status', 'action']"></tr>
                      <tr mat-row *matRowDef="let row; columns: ['versionNumber', 'creationDate', 'status', 'action']"></tr>
                    </table>
                  </div>
                  
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

        </div>

    </mat-card-content>
</mat-card>


<!-- modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier échantillon
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="updateRapport()">
                <div class="row">
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Numéro du Rapport</mat-label>
                            <input matInput formControlName="reportNumber" placeholder="Ex. 12345">
                            <mat-error *ngIf="form.get('reportNumber')?.hasError('required')">
                                Numéro du Rapport requis
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-6 col-lg-12">
                        <mat-form-field class="mb-25">
                            <mat-label>Interprétations</mat-label>
                            <textarea matInput formControlName="interpretations"
                                      placeholder="Ex. Analyse des données"></textarea>
                            <mat-error *ngIf="form.get('interpretations')?.hasError('required')">
                                Interprétations requis
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Client Name -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom du Client</mat-label>
                            <input matInput formControlName="clientName" placeholder="Ex. Nom du client">
                            <mat-error *ngIf="form.get('clientName')?.hasError('required')">
                                Nom du Client requis
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- User Name -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom de l'Utilisateur</mat-label>
                            <input matInput formControlName="userName" placeholder="Ex. Nom de l'utilisateur">
                            <mat-error *ngIf="form.get('userName')?.hasError('required')">
                                Nom de l'Utilisateur requis
                            </mat-error>
                        </mat-form-field>
                    </div>

                </div>

                <!-- Submit Button -->
                <div class="col-sm-12 text-right mt-3">
                    <button type="submit" class="btn btn-outline-success">Sauvegarder</button>
                </div>
            </form>

        </mat-card-content>
    </mat-card>
</ng-template>


<!-- modal template for infos -->
<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <h5 class="m-3 model-title-style">Détails de le Rapport</h5>
            <div class="row m-3">
                <!--                        Numéro de rapport-->
                <div class="col-sm-6 border-top border-0 p-3 ">
                    <div class="font-weight-bold">Numéro de rapport :</div>
                    <p>{{ rapport?.reportNumber }}</p>
                </div>

                <!--                        interprétations-->
                <div class="col-sm-6 border-top border-0 p-3 ">
                    <div class="font-weight-bold">Interprétations :</div>
                    <p>{{ rapport?.interpretations }}</p>
                </div>

                <!--                        clientName-->
                <div class="col-sm-6 border-top border-0 p-3 ">
                    <div class="font-weight-bold">Nom du client :</div>
                    <p>{{ rapport?.clientName }}</p>
                </div>

                <!-- Code échantillon -->
                <div class="col-sm-6 border-top border-0 p-3">
                    <div class="font-weight-bold">Code échantillon :</div>
                    <div *ngFor="let sample of rapport?.samples">
                        <p>{{ sample.sampleCode }}</p>
        
                        <hr>
                    </div>
                </div>
                
                <!--                        userName-->
                <div class="col-sm-6 border-top border-0 p-3 ">
                    <div class="font-weight-bold">Céé par :</div>
                    <p>{{ rapport?.userName }}</p>
                </div>

                <!--                        creationDate-->
                <div class="col-sm-6 border-top border-0 p-3 ">
                    <div class="font-weight-bold">Céé le :</div>
                    <p>{{ rapport?.creationDate | date : 'short' }}</p>
                </div>

                <!--                        updateDate-->
                <div class="col-sm-6 border-top border-0 p-3 ">
                    <div class="font-weight-bold">Modifié le :</div>
                    <p>{{ rapport?.updateDate | date : 'short' }}</p>
                </div>

            </div>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>



